import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  width: 12,
  height: 12,
  viewboxWidth: 12,
  viewboxHeight: 12,
};

const ChatBubbleIcon = ({
  width = defaults.width,
  height = defaults.height,
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
      {...rest}
    >
      <g>
        <path
          d="M1.5 0.00195312H11.5C11.7652 0.00195312 12.0196 0.10731 12.2071 0.294846C12.3946 0.482383 12.5 0.736737 12.5 1.00195V7.75195C12.5 8.01717 12.3946 8.27152 12.2071 8.45906C12.0196 8.6466 11.7652 8.75195 11.5 8.75195H6.64L3.52 10.912C3.44711 10.9613 3.3625 10.9905 3.2747 10.9966C3.18691 11.0028 3.09905 10.9856 3.02 10.947C2.93848 10.9047 2.87016 10.8409 2.82253 10.7624C2.7749 10.6839 2.74981 10.5938 2.75 10.502V8.75195H1.5C1.23906 8.75204 0.988421 8.65012 0.801587 8.46795C0.614753 8.28579 0.506524 8.03781 0.5 7.77695V1.00195C0.5 0.736737 0.605357 0.482383 0.792893 0.294846C0.98043 0.10731 1.23478 0.00195312 1.5 0.00195312Z"
          fill="currentColor"
        />
      </g>
    </SVGLoader>
  );
};

export default ChatBubbleIcon;
